import { createFileRoute } from "@tanstack/react-router";

import ProfileSkeleton from "@/components/loadings/skeleton/ProfileSkeleton";
import { type ChildRouteContext } from "@/root";

import ProfileForm from "@/modules/profile/user/components/ProfileForm";
import { fetchProfileQueryOptions } from "@/modules/profile/user/services";

export const Route = createFileRoute("/_panel/_profile/profile/me")({
  component: Component,
  pendingComponent: ProfileSkeleton,
  beforeLoad: ({ context }) =>
    ({
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Profile", { ns: "profile.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchProfileQueryOptions("me")),
});

function Component() {
  return <ProfileForm id="me" />;
}
